import { Counter } from "../../../../src/components/Counter";
import React from 'react';
export default {
  Counter,
  React
};